import configure from 'redux-idle-monitor';
import { get } from 'lodash';
import { logout, sessionExpireDialog } from '../../screens/Login/actions';

export const IDLESTATUS_AWAY = 'AWAY';
export const IDLESTATUS_OUT = 'OUT';
const IDLE_STATUSES = [IDLESTATUS_AWAY, IDLESTATUS_OUT];
const IDLE_TIMEOUT_DEFAULT = 15 * 60 * 1000;

export const idleStatusDelay = (idleStatus) => (dispatch, getState) => {
  const state = getState();
  let awayTimeout = IDLE_TIMEOUT_DEFAULT;
  const confIdleTimeout = get(state, 'appConfig.config.idleTimeoutMinutes');

  if (confIdleTimeout) {
    awayTimeout = confIdleTimeout * 60 * 1000;
  }

  const outTimeout = 60 * 1000; // User is logging after 1 minutes after away status

  if (idleStatus === IDLESTATUS_AWAY) {
    return awayTimeout;
  } // User becomes away after n minutes inactivity
  if (idleStatus === IDLESTATUS_OUT) {
    return outTimeout;
  }
};

export const activeStatusAction = (dispatch, getState) => {};

export const idleStatusAction = (idleStatus) => (dispatch) => {
  if (idleStatus === IDLESTATUS_AWAY) {
    dispatch(sessionExpireDialog());
  }
  if (idleStatus === IDLESTATUS_OUT) {
    dispatch(logout());
  }
};

// These are the default events that will trigger user active status but can be customized if provided.
const activeEvents = [
  'mousemove',
  'keydown',
  'wheel',
  'DOMMouseScroll',
  'mouseWheel',
  'mousedown',
  'touchstart',
  'touchmove',
  'MSPointerDown',
  'MSPointerMove',
];

const opts = {
  appName: 'i2p2_viz_app',
  IDLE_STATUSES,
  idleStatusDelay,
  activeStatusAction,
  idleStatusAction,
  activeEvents,
};

const { middleware, reducer, actions } = configure(opts);

export { middleware, reducer, actions };
